import List from './List';
import Add from './Add';
import Edit from './Edit';
import React from 'react';
import {
  AnyAssetApplication,
  assetConfigurations,
  ConfigProvider,
  useAssetParams,
} from '@mss/mss-component-library';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Import from './Import';
import MonitorProfileSettings from './MonitorProfileSettings';
import Discovery from './Discovery';
import BulkOperationPage from './BulkOperationPage';

const routesFactory = (path: string) => ({
  root: `${path}/`,
  add: `${path}/add`,
  monitorProfiles: `${path}/monitor-profiles`,
  edit: `${path}/:assetSubType/:assetId`,
  import: `${path}/import`,
  discovery: `${path}/discovery`,
  bulkEdit: `${path}/bulk-edit`,
  bulkDelete: `${path}/bulk-delete`,
});

function AssetPage<AssetType extends AnyAssetApplication>() {
  const { path } = useRouteMatch();
  const { assetType } = useAssetParams();
  const routes = routesFactory(path);

  if (!assetConfigurations[assetType]) {
    return <h1>404 - Not found</h1>;
  }

  return (
    <ConfigProvider<AssetType> value={assetConfigurations[assetType]}>
      <Switch>
        <Route path={routes.root} exact component={List} />
        <Route path={routes.import} component={Import} />
        <Route path={routes.discovery} component={Discovery} />
        <Route
          path={routes.monitorProfiles}
          component={MonitorProfileSettings}
        />
        <Route path={routes.add} component={Add} />
        <Route path={routes.edit} component={Edit} />
        <Route
          path={routes.bulkEdit}
          exact
          render={() => <BulkOperationPage mode="edit" />}
        />
        <Route
          path={routes.bulkDelete}
          exact
          render={() => <BulkOperationPage mode="delete" />}
        />
      </Switch>
    </ConfigProvider>
  );
}

export default AssetPage;
